<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="orderNo"
      :itemNames="['name_1','name_2','name_3','name_4']"
      :columns="getColumns()"
      :col="5"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :buttonItems="['apply']"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,getCheckboxProps: this.getCheckboxProps }"
    >
      <a-form-item slot="name_1" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="联系人名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderContact" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="联系人手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderMobile" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_4" label="签署状态" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.orderContract"
          placeholder="请选择" allowClear
        >
          <a-select-option :value="0">未签署</a-select-option>
          <a-select-option :value="1">签署中</a-select-option>
          <a-select-option :value="2">已签署</a-select-option>
          <a-select-option :value="3">作废中</a-select-option>
          <a-select-option :value="4">已作废</a-select-option>
        </a-select>
      </a-form-item>
      <a-button
        slot="apply"
        style="margin-left: 8px"
        htmlType="submit"
        type="primary"
        :disabled="!selectedRowKeys.length"
        @click="submitEvent"
        :loading="submitLoading"
      >申请合同
      </a-button>
      <div slot="proSlots" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span v-if="rowItem.record.orderOptionName">【{{ rowItem.record.orderOptionName }}】</span>
            {{ rowItem.record.orderMainProName }}
          </template>
          <div class="pro_name">
            <span v-if="rowItem.record.orderOptionName">【{{ rowItem.record.orderOptionName }}】</span>
            {{ rowItem.record.orderMainProName }}
          </div>
        </a-tooltip>
      </div>
      <span slot="orderActualSales" slot-scope="rowItem">
        ￥{{ rowItem.record.orderActualSales }}
      </span>
      <span slot="orderContact" slot-scope="rowItem">
        {{ rowItem.record.orderContact }}({{ rowItem.record.orderMobile }})
      </span>
      <a-alert style="margin-bottom: 10px" slot="operation" v-if="selectedRowKeys.length > 0"
               :message="`已选择 ${selectedRowKeys.length} 项`" type="info"/>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'ElectronicContractOrder',
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      submitLoading: false,
      serverUniqueId: this.$route.query.serverUniqueId,
      serverId: this.$route.query.serverId,
      selectedRowKeys: [],
      proCatalog: '' // 商品类型Id 73出境游 74国内游
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('contract/order/list', params)
    },
    getColumns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: '200px'
        },
        {
          title: '商品信息',
          scopedSlots: { customRender: 'proSlots' }
        },
        {
          title: '数量',
          dataIndex: 'orderTotalQty',
          width: '100px'
        },
        {
          title: '订单金额',
          dataIndex: 'orderActualSales',
          scopedSlots: { customRender: 'orderActualSales' },
          width: '120px'
        },
        {
          title: '联系人',
          dataIndex: 'orderContact',
          scopedSlots: { customRender: 'orderContact' },
          width: '200px'
        },
        {
          title: '下单时间',
          dataIndex: 'orderCreateTime',
          width: '180px'
        },
        {
          title: '签署状态',
          dataIndex: 'orderContractStr',
          width: '100px'
        }
      ]
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      const keys = []
      selectedRows.forEach((item, index, arr) => {
        // 多选订单发起合同签属，条件：同一商品、同一行程、同一套餐、同一日期
        if (item.orderMainProId === selectedRows[0].orderMainProId && item.orderOptionId === selectedRows[0].orderOptionId && item.orderTravelDate === selectedRows[0].orderTravelDate) {
          keys.push(item.orderNo)
          this.proCatalog = selectedRows[0].orderType
        }
      })
      this.selectedRowKeys = keys
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.orderContract !== 0
        }
      }
    },
    submitEvent() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('tourist/contract/validateProCatalog', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          proCatalog: this.proCatalog
        }).then(res => {
          this.openNewPage('ElectronicContractDetail', {
            serverId: this.serverId,
            serverUniqueId: this.serverUniqueId,
            orderNoList: JSON.stringify(this.selectedRowKeys),
            proCatalog: this.proCatalog,
            type: '1'
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pro_name {
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
